import React, { ReactNode } from "react";

const Grid = ({
    children,
    className = "",
}: {
    children: ReactNode;
    className?: string;
}) => {
    return (
        <div className={`grid gap-4 ${className ? className : "grid-cols-1"}`}>
            {children}
        </div>
    );
};

export default Grid;
